import React from "react";
import moment from "moment";
import { isValidMessageUrl } from "../utils";

export default function MessageBubble({
  item,
  accountIndex,
  userData,
  onAssetOpen,
  onFileDownload,
}) {
  const isOtherUser = item?.provider_alias === "customer";
  const hasFiles = item?.files?.length > 0;
  const primaryFile = item?.files?.[0];

  const senderLabel =
    accountIndex?.id !== item?.sender_id && item?.sender_id !== null ? (
      <span className="messaging__content-techsbookSup">
        {userData?.name} <p>technician</p>
      </span>
    ) : !item?.sender_id ? (
      <span className="messaging__content-techsbookSup">
        Techsbook <p>support</p>
      </span>
    ) : null;

  return (
    <div
      className={`messaging__wrapper-link ${
        isOtherUser ? "messaging__wrapper-link_other" : ""
      }`}
    >
      {senderLabel}
      {hasFiles ? (
        <div
          className={`messaging__content-message ${
            isOtherUser ? "messaging__content-message_other" : ""
          }`}
          onClick={() => {
            if (primaryFile?.type === "image" || primaryFile?.type === "video") {
              onAssetOpen(primaryFile);
            } else if (primaryFile?.type === "file") {
              onFileDownload(primaryFile);
            }
          }}
          rel="noreferrer"
        >
          <div className="messaging__content-excel">
            <span>
              {primaryFile?.type === "file" ? (
                <img src="/assets/icons/file-chat-2.svg" alt="" />
              ) : primaryFile?.type === "video" ? (
                <div className="video-preview">
                  <img src="/assets/icons/video.svg" alt="" />
                </div>
              ) : (
                <img src={primaryFile?.full_path} alt="" />
              )}
            </span>
            <div>
              <p className="messaging__content-messageName">
                {`${primaryFile?.full_path?.substring(0, 50)}...`}
              </p>
            </div>
          </div>
          <p className="messaging__content-messageTime">
            {moment(primaryFile?.updated_at).format("MM-DD-YYYY hh:mm A")}
          </p>
        </div>
      ) : (
        <div
          className={`messaging__content-message ${
            isOtherUser ? "messaging__content-message_other" : ""
          }`}
        >
          {!isValidMessageUrl(item?.content) ? (
            <pre
              className={`messaging__content-messageText ${
                isOtherUser ? "messaging__content-messageText_other" : ""
              }`}
            >
              {item?.content}
            </pre>
          ) : (
            <a
              target="_blank"
              rel="noreferrer"
              href={item?.content}
              className={`url messaging__content-messageText ${
                isOtherUser ? "messaging__content-messageText_other" : ""
              }`}
            >
              {item?.content}
            </a>
          )}
          <p className="messaging__content-messageTime">
            {moment(item?.updated_at).format("MM-DD-YYYY hh:mm A")}
          </p>
        </div>
      )}
    </div>
  );
}
